import { useLayoutEffect } from 'react';
import { useDeviceType } from '../../../../responsive';
/**
 * Хук, который управляет CSS-свойствами индикатора для активного таба
 */
export var useActiveIndicatorChange = function useActiveIndicatorChange(_ref) {
  var containerRef = _ref.containerRef,
    activeTabIndex = _ref.activeTabIndex;
  var deviceType = useDeviceType();
  useLayoutEffect(function () {
    var tabsNode = containerRef.current;
    if (tabsNode) {
      var activeTab = tabsNode.children.item(activeTabIndex);
      var _activeTab$getBoundin = activeTab.getBoundingClientRect(),
        left = _activeTab$getBoundin.left,
        width = _activeTab$getBoundin.width;
      var distanceFromParent = left - tabsNode.getBoundingClientRect().left + tabsNode.scrollLeft;
      tabsNode.style.setProperty('--indicator-offset', "".concat(distanceFromParent, "px"));
      tabsNode.style.setProperty('--indicator-width', "".concat(width, "px"));
    }
  }, [activeTabIndex, containerRef, deviceType]);
};